export const generatePaypalID = () => `paypal-button-${Date.now()}`
